import * as types from 'store/modules/hres4ax/mutation-types'
import hres4ax from 'api/hres4ax'
import swal from 'sweetalert'
import hres4axLabels from 'assets/labels/hres4ax'
import { hres4axColumns } from 'assets/columns/hres4ax'
import configLabel from 'src/../config/label'

let recursiveDataChildren = (data, dataRowsFiltered, counter) => {
  if (counter === 0) {
    let dataFilteredOrgid = dataRowsFiltered.filter(dataRow => dataRow.parentorgid === data.orgid)
    if (dataFilteredOrgid.length > 0) {
      data.children = dataFilteredOrgid
    }
  } else {
    if (typeof data.children !== 'undefined') {
      for (let dataRow of data.children) {
        recursiveDataChildren(dataRow, dataRowsFiltered, counter - 1)
      }
    }
  }
}

export default {
  state: {
    indexDisp: true,
    detailDisp: false,
    labels: hres4axLabels,
    columns: hres4axColumns(),
    index: {
      total: 0,
      rows: []
    },
    indexSelected: {},
    detail: {
      detail: {},
      table: {
        total: 0,
        rows: []
      }
    },
    popup1: {
      detail: {},
      tab1: {
        total: 0,
        rows: []
      },
      tab2: {
        total: 0,
        rows: []
      },
      tab3: {
        total: 0,
        rows: []
      }
    },
    popup2: {
      tab1: {},
      tab2: {
        total: 0,
        rows: []
      },
      tab3: {
        total: 0,
        rows: []
      }
    }
  },
  getters: {
    [types.GET_HRES4AX_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRES4AX_DETAIL_DISP] (state) {
      return state.detailDisp
    },
    [types.GET_HRES4AX_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRES4AX_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRES4AX_INDEX] (state) {
      return state.index
    },
    [types.GET_HRES4AX_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRES4AX_DETAIL] (state) {
      return state.detail
    },
    [types.GET_HRES4AX_POPUP1] (state) {
      return state.popup1
    },
    [types.GET_HRES4AX_POPUP2] (state) {
      return state.popup2
    }
  },
  mutations: {
    [types.SET_HRES4AX_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRES4AX_DETAIL_DISP] (state, detailDisp) {
      state.detailDisp = detailDisp
    },
    [types.SET_HRES4AX_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
        state.columns[keyLang].popup1Tab1Table = configLabel.replaceLabelToColumns(state.columns[keyLang].popup1Tab1Table, labels[keyLang])
        state.columns[keyLang].popup1Tab2Table = configLabel.replaceLabelToColumns(state.columns[keyLang].popup1Tab2Table, labels[keyLang])
        state.columns[keyLang].popup1Tab3Table = configLabel.replaceLabelToColumns(state.columns[keyLang].popup1Tab3Table, labels[keyLang])
        state.columns[keyLang].popup2Tab2Table = configLabel.replaceLabelToColumns(state.columns[keyLang].popup2Tab2Table, labels[keyLang])
        state.columns[keyLang].popup2Tab3Table = configLabel.replaceLabelToColumns(state.columns[keyLang].popup2Tab3Table, labels[keyLang])
      }
    },
    [types.SET_HRES4AX_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_HRES4AX_INDEX] (state, data) {
      state.index = data
    },
    [types.SET_HRES4AX_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRES4AX_DETAIL] (state, data) {
      // filter keys
      let allowKeys = [
        'orgid',
        'parentorgid',
        'codcompy',
        'desc_codcompy',
        'codlinef',
        'desc_codlinef',
        'dteeffec',
        'codcomp',
        'desc_codcomp',
        'codpospr',
        'desc_codpos',
        'complvl',
        'codsupvi',
        'desc_supvi',
        'imgsupvi',
        'imgsupvipath',
        'codassis',
        'desc_assis',
        'imgassis',
        'imgassispath',
        'codcomp_assis',
        'desc_codcomp_assis',
        'codpos_assis',
        'desc_codpos_assis'
      ]
      let dataRows = []
      for (let dataRow of data.rows) {
        let dataRowKeyFiltered = Object.keys(dataRow)
          .filter(key => allowKeys.includes(key))
          .reduce((obj, key) => {
            obj[key] = dataRow[key]
            return obj
          }, {})
        dataRows.push(dataRowKeyFiltered)
      }

      // map detail
      let detail = {}
      let complvlRoot = 0
      for (let complvl = 1; complvl <= 7; complvl++) {
        let dataRowsFilteredByComplvl = dataRows.filter(dataRow => dataRow.complvl === complvl.toString())
        if (dataRowsFilteredByComplvl.length === 0) {
          if (complvlRoot > 0) break
        } else {
          if (complvlRoot === 0) { // first row
            complvlRoot = complvl
            detail = Object.assign({}, dataRowsFilteredByComplvl[0])
          } else { // others row
            recursiveDataChildren(detail, dataRowsFilteredByComplvl, complvl - complvlRoot - 1)
          }
          // if (complvl === 4) {
          //   console.log(JSON.stringify(detail))
          // }
        }
      }
      state.detail = detail
    },
    [types.SET_HRES4AX_POPUP1] (state, data) {
      state.popup1 = data
    },
    [types.SET_HRES4AX_POPUP2] (state, data) {
      state.popup2 = data
    }
  },
  actions: {
    [types.TOGGLE_HRES4AX_PAGE] ({ commit }, page) {
      let indexDisp = false
      let detailDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'detail':
          detailDisp = true
          break
      }
      commit(types.SET_HRES4AX_INDEX_DISP, indexDisp)
      commit(types.SET_HRES4AX_DETAIL_DISP, detailDisp)
    },
    [types.RECEIVED_HRES4AX_COLUMNS_LABELS] ({ commit }) {
      hres4ax.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES4AX_COLUMNS, data.labels)
          commit(types.SET_HRES4AX_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES4AX_INDEX] ({ commit }, searchParams) {
      hres4ax.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES4AX_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES4AX_DETAIL] ({ commit }, dataRow) {
      hres4ax.getDetail(dataRow)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES4AX_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES4AX_POPUP1] ({ commit }, dataRow) {
      hres4ax.getPopup1(dataRow)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES4AX_POPUP1, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES4AX_POPUP2] ({ commit }, dataRow) {
      hres4ax.getPopup2(dataRow)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES4AX_POPUP2, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hres4ax/index.js